export default __webpack_public_path__ + "static/figure-2-8c152993c0bd68905a977ea9059dde17.webp";